/**
The main entry point for the Gallery page.

Referenced by the page.gallery.liquid template.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'urql';
import './scss/templates/gallery.scss';
import Gallery from './components/Gallery';
import graphqlClient from './utils/graphqlClient';
import { jsx as _jsx } from "react/jsx-runtime";
var search = window.location.search; // eslint-disable-line

var urlParams = new URLSearchParams(search);
var client = graphqlClient(urlParams);
ReactDOM.render( /*#__PURE__*/_jsx(Provider, {
  value: client,
  children: /*#__PURE__*/_jsx(Gallery, {})
}), document.getElementById('page-gallery'));